import React from 'react';
import { Button, ButtonGroup } from "react-bootstrap";

const Row = ({ source, sourceName, enabled, onUpdate, onFactors }) => {
    return (<tr>
        <td style={{ textAlign: 'left' }}>{sourceName}</td>
        <td>
            <ButtonGroup>
                {
                    enabled ?
                        <Button bsStyle={'danger'} onClick={() => onUpdate(source, 0)}>Disable</Button> :
                        <Button bsStyle={'success'} onClick={() => onUpdate(source, 1)}>Enable</Button>

                }

                <Button bsStyle={"info"} onClick={() => onFactors(source)}>Factors</Button>
            </ButtonGroup>
        </td>
    </tr>);

};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/BidderWinRateConfig/components/Table/components/Row/index.js